import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../components/admin/TeacherAdmin/layout/Layout";
import Classroom from "../components/admin/TeacherAdmin/classroom/Classroom";
import CreateClassroom from "../components/admin/TeacherAdmin/classroom/CreateClassroom";
import UpdateClassroom from "../components/admin/TeacherAdmin/classroom/UpdateClassroom";
import ClassRoomDetail from "../components/admin/TeacherAdmin/classroom/classroomDetail/ClassRoomDetail";
import ClassroomReport from "../components/admin/TeacherAdmin/classroom/ClassroomReport/ClassroomReport";
import StudentDetail from "../components/admin/TeacherAdmin/student/StudentDetail";
import Student from "../components/admin/TeacherAdmin/student/Student";
import CreateLesson from "../components/admin/TeacherAdmin/lesson/CreateLesson";
import UpdateLesson from "../components/admin/TeacherAdmin/lesson/UpdateLesson";
import Lessons from "../components/admin/TeacherAdmin/lesson/Lessons";
import QuestDetail from "../components/admin/TeacherAdmin/student/QuestDetail";
import Settings from "../components/admin/TeacherAdmin/setting/Settings";
import Quest from "../components/admin/TeacherAdmin/quest/Quest";
import TenantProtectedRoutes from "./TenantProtectedRoutes";
import CreateStudent from "../components/admin/SchoolAdmin/Student/CreateStudent";
import Dashboard from "../components/admin/TeacherAdmin/Dashboard/Dashboard";
import UpdateStudentDetail from "../components/admin/TeacherAdmin/student/UpdateStudentDetail";
import ImportHistoryLayout from "../components/admin/SchoolAdmin/ImportHistory/ImportHistoryLayout";
import StudentImportHistory from "../components/admin/SchoolAdmin/ImportHistory/StudentImportHistory";
import TeacherImportHistory from "../components/admin/SchoolAdmin/ImportHistory/TeacherImportHistory";
import ImportLogDetail from "../components/admin/SchoolAdmin/ImportHistory/ImportLogDetail";
import SchoolCreateNotification from "../components/admin/SchoolAdmin/Notification/CreateNotification";
import { SchoolNotifications } from "../components/admin/SchoolAdmin/Notification/Notification";
import { NotificationDetail } from "../components/admin/SchoolAdmin/Notification/NotificationDetail";
import { SchlStudentNotifications } from "../components/admin/StudentAdmin/Notification/StudentNotification";
import { SchlStudentNotificationDetail } from "../components/admin/StudentAdmin/Notification/StudentNotificationDetail";
import QuizOverview from "../components/admin/TeacherAdmin/quiz/QuizOverview";
import QuizLimitInfo from "../components/admin/TeacherAdmin/quiz/QuizLimitInfo";

const TeacherAdminRoutes = () => {
  return (
    <>
      <Routes>
        <Route
          path=""
          element={
            <TenantProtectedRoutes tenantType="teacher">
              <Layout />
            </TenantProtectedRoutes>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="student" element={<Student />} />
          <Route path="student/update/:id" element={<UpdateStudentDetail />} />
          <Route
            path="student/create"
            element={<CreateStudent type="student" />}
          />
          <Route path="student/:id" element={<StudentDetail />} />
          <Route path="student/:id/:questId" element={<QuestDetail />} />

          <Route path="classroom" element={<Classroom />} />
          <Route path="classroom/create" element={<CreateClassroom />} />
          <Route
            path="classroom/detail/:id"
            element={<ClassRoomDetail type="teacher" />}
          />
          <Route
            path="classroom/report/:id"
            element={<ClassroomReport type="teacher" />}
          />
          <Route path="classroom/update/:id" element={<UpdateClassroom />} />

          <Route path="lesson" element={<Lessons type="Teacher" />} />
          <Route path="lesson/create" element={<CreateLesson />} />
          <Route path="lesson/update/:id" element={<UpdateLesson />} />

          <Route path="quest" element={<Quest />} />

          <Route path="quiz" element={<QuizOverview />} />
          <Route path="quiz/classroom/:id" element={<QuizLimitInfo />} />

          <Route path="notifications" element={<SchoolNotifications />} />
          <Route
            path="reciever/notifications"
            element={<SchlStudentNotifications />}
          />
          <Route
            path="reciever/notification/view/:id"
            element={<SchlStudentNotificationDetail />}
          />
          <Route
            path="notification/create"
            element={<SchoolCreateNotification />}
          />
          <Route
            path="notification/detail/:batch_id"
            element={<NotificationDetail />}
          />

          <Route path="settings" element={<Settings />} />
          <Route
            path="import-history"
            element={<ImportHistoryLayout type="teacher" />}
          >
            <Route index element={<Navigate to="students" replace />} />
            <Route
              path="students"
              element={<StudentImportHistory type="teacher" />}
            />
            <Route
              path="students/:logId"
              element={<ImportLogDetail type="teacher" />}
            />
            <Route
              path="teachers"
              element={<TeacherImportHistory type="teacher" />}
            />
            <Route
              path="teachers/:logId"
              element={<ImportLogDetail type="teacher" />}
            />
          </Route>
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Route>
      </Routes>
    </>
  );
};

export default TeacherAdminRoutes;
